
import { defineComponent, PropType } from "vue";
import { IPreschoolPerformancesModel, IPreschoolDimensionsModel } from "@/interfaces/modules";
import PreschoolPerformancesService from "@/api/Preschool/PreschoolPerformancesService";
import PreschoolDimensionsService from "@/api/Preschool/PreschoolDimensionsService";
import store from "@/store";

export default defineComponent({
  name: "PreschoolPerformancesContent",
  props: {
    dimension: {
      type: Object as PropType<IPreschoolDimensionsModel | null>,
      required: true,
    },
  },
  data() {
    return {
      dimensions: [] as any[],
      form: {
        dialog: false,
        record: {} as IPreschoolPerformancesModel,
      },
      table: {
        filters: { search: "" },
        currentPage: 1,
        loading: false,
        headers: [
          { key: "DimensionId", label: "Dimensión", sortable: true },
          { key: "Code", label: "Código", sortable: true },
          { key: "Description", label: "Descripción", sortable: true },
          { key: "Status", label: "Activo", sortable: true },
          { key: "CreatedByFormat", label: "Creación", sortable: true },
          { key: "ModifiedByFormat", label: "Última modificación", sortable: true },
          { key: "action", label: "Acciones", sortable: false },
        ],
        records: [] as IPreschoolPerformancesModel[],
        rowsPerPage: 10,
      } as any,
    };
  },

  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter((item: any) =>
          item.Description?.toLowerCase().includes(
            this.table.filters.search.toLowerCase()
          )
        )
        : this.table.records;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },

  async mounted() {
    await this.load();
  },

  methods: {
    async load() {
      this.table.loading = true;
      let _records = await PreschoolPerformancesService.GetPreschoolPerformances();
      this.table.records = _records.filter((r) => r.DimensionId === this.dimension?.Id);
      this.dimensions = await PreschoolDimensionsService.GetPreschoolDimensions();
      this.table.loading = false;
    },
    async edit(data: IPreschoolPerformancesModel) {
      this.form.record =
        await PreschoolPerformancesService.GetPreschoolPerformanceById({
          Id: data.Id,
        });
      this.form.dialog = true;
    },
    openModal() {
      this.form.record = { Status: true, DimensionId: this.dimension?.Id } as IPreschoolPerformancesModel;
      this.form.dialog = true;
    },
    async handleSubmit(event: Event) {
      event.preventDefault();
      this.form.dialog = false;
      await PreschoolPerformancesService.PostPreschoolPerformance(
        this.form.record
      );

      store.dispatch("core/popupDialog", {
        text: "Registro guardado con éxito.",
        type: "success",
        showCancelButton: false,
      });

      this.load();
    },
  },
});
